import { Input, Directive, input } from "@angular/core";
import { NgForm, NgModel } from "@angular/forms";
import { SelectItem } from 'primeng/api';
import { SharedControl } from "../../classes/sharedcontrol";
import { Community, SubGroup } from "../../types";

@Directive()
export abstract class PCPCommunitySelectorBaseComponent extends SharedControl {
    readonly marketId = input<number>(undefined);
    readonly selectionLimit = input<number>(null);
    readonly required = input<boolean>(false);
    readonly parentForm = input<NgForm>(null);
    readonly isOneOfManyRequired = input<boolean>(false);
    // TODO: Skipped for migration because:
    //  This input is inherited from a superclass, but the parent cannot be migrated.
    @Input() disabled: boolean = false;

    registerControlWithParent(model: NgModel) {
        const parentForm = this.parentForm();
        if (!parentForm || parentForm === null) { return; }

        parentForm.addControl(model);
    }

    communitiesToOptions(communities: Community[]): SelectItem[] {
        return communities.map((community) => {
            const displayText = this.getCommunityDisplayText(community);
            return { label: displayText, value: community };
        });
    }

    getCommunityDisplayText(community: Community) {
        return community.orgId !== 0 ? `${community.orgName.trim()} (${community.sourceKey})` : community.orgName.trim();
    }

    sortSelectedTop(allCommunities: Community[], selectedCommunities: Community[]): Community[] {
        if (!allCommunities || allCommunities.length === 0) { return []; }

        const unselectedCommunities = allCommunities.filter((community) => !this.communityIsInSelectedCommunities(community, selectedCommunities) && !this.isNoAssociatedCommunity(community));
        const selectCommunities = allCommunities.filter((community) => this.communityIsInSelectedCommunities(community, selectedCommunities) && !this.isNoAssociatedCommunity(community));
        const noAssociatedCommunity: Community = allCommunities.find((community) => this.isNoAssociatedCommunity(community));

        const alphabetically = (a: Community, b: Community) => (a.orgName > b.orgName) ? 1 : -1;
        const alphabeticallySortedUnselectedCommunities = unselectedCommunities.sort(alphabetically);
        const alphabeticallySortedSelectedCommunities = selectCommunities.sort(alphabetically);

        if (noAssociatedCommunity) {
            if (this.communityIsInSelectedCommunities(noAssociatedCommunity, selectedCommunities)) {
                alphabeticallySortedSelectedCommunities.unshift(noAssociatedCommunity);
            } else {
                alphabeticallySortedUnselectedCommunities.unshift(noAssociatedCommunity);
            }
        }

        alphabeticallySortedUnselectedCommunities.unshift(...alphabeticallySortedSelectedCommunities);

        const allSortedCommunities = alphabeticallySortedUnselectedCommunities;

        return allSortedCommunities;
    }

    communitiesBySubGroup(communities: Community[], subGroup: SubGroup): Community[] {
        return communities.filter((community) => this.subGroupContainsCommunity(subGroup, community));
    }

    private subGroupContainsCommunity(subGroup: SubGroup, community: Community): boolean {
        return subGroup.communities.some((c) => c.orgId === community.orgId);
    }

    private communityIsInSelectedCommunities(community: Community, selectedCommunities: Community[]): boolean {
        if (!selectedCommunities || selectedCommunities.length === 0) { return false; }

        return selectedCommunities.some((selectedCommunity) => selectedCommunity.orgId === community.orgId);
    }

    private isNoAssociatedCommunity(community: Community): boolean {
        return community.orgId === 0;
    }
}